import { render, staticRenderFns } from "./CajaResumen.vue?vue&type=template&id=0b9df00c&scoped=true&lang=pug"
import script from "./CajaResumen.vue?vue&type=script&lang=js"
export * from "./CajaResumen.vue?vue&type=script&lang=js"
import style0 from "./CajaResumen.vue?vue&type=style&index=0&id=0b9df00c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9df00c",
  null
  
)

export default component.exports